import { loadScript, PayPalNamespace } from '@paypal/paypal-js';
import { PayPalScriptOptions } from '@paypal/paypal-js/types/script-options';
import * as Sentry from "@sentry/vue";

export default async ({ $config, store }: { $config: any, store: any}, inject: (key: string, value: any) => void) => {
  let paypalInstance: any = null;
  const loadPayPalScript = async (customerId?: string) => {
    if (store.getters['ship/stepName']?.toLowerCase() === 'payment') {
      const options: PayPalScriptOptions = {
        clientId: $config.paypalClientId,
        currency: 'USD',
        vault: true,
        dataUserIdToken: customerId
      };
      try {
        const oldScript = document.querySelector('script[src*="paypal.com/sdk/js"]');
        if (oldScript) oldScript.remove();

        paypalInstance = await loadScript(options);
        Object.assign(paypalObject, {
          ...paypalInstance,
          Buttons: paypalInstance.Buttons,
          reload: loadPayPalScript
        });
        return paypalInstance;

      } catch (error) {
        Sentry.captureException(error);
        return null;
      }
    };
  };

    // Crear objeto inicial que será inyectado
  const paypalObject = {
    loadPayPalScript,
    reload: loadPayPalScript
  };
  
  inject('paypal', paypalObject);
};